export default __webpack_public_path__ + "static/media/WeChatQRCode.4715414d.jpg";